/**
 * @fileoverview Données mockées du portail.
 *
 * Elles servent uniquement au design et aux états frontend. Le contrat réel
 * reste `Documents/openapi.yaml`.
 *
 * Le jeu couvre volontairement les BORNES FR-03 : plus de 10 contraventions
 * (le plafond « max 10 par paiement » devient testable) et des montants
 * dont le cumul dépasse 2 000 000 XOF (le plafond Paymetrust devient
 * atteignable en sélectionnant les lignes les plus chères).
 */

export interface MockContravention {
  liquidationNumber: string;
  infractionType: string;
  amount: number;
  infractionDate: string;
  dueDate: string;
}

export const MOCK_PLATE = 'AB572GG';

export const MOCK_CONTRAVENTIONS: readonly MockContravention[] = [
  {
    liquidationNumber: 'LIQ-921555',
    infractionType: 'Excès de vitesse',
    amount: 45000,
    infractionDate: '2026-07-08T08:20:00Z',
    dueDate: '2026-08-08T23:59:00Z',
  },
  {
    liquidationNumber: 'LIQ-921556',
    infractionType: 'Stationnement interdit',
    amount: 12000,
    infractionDate: '2026-07-10T12:40:00Z',
    dueDate: '2026-08-10T23:59:00Z',
  },
  {
    liquidationNumber: 'LIQ-921557',
    infractionType: 'Non-respect du feu tricolore',
    amount: 60000,
    infractionDate: '2026-07-12T18:05:00Z',
    dueDate: '2026-08-12T23:59:00Z',
  },
  {
    liquidationNumber: 'LIQ-921558',
    infractionType: "Défaut d'assurance",
    amount: 250000,
    infractionDate: '2026-07-05T09:15:00Z',
    dueDate: '2026-08-05T23:59:00Z',
  },
  {
    liquidationNumber: 'LIQ-921559',
    infractionType: 'Surcharge de marchandises',
    amount: 500000,
    infractionDate: '2026-06-28T14:30:00Z',
    dueDate: '2026-07-28T23:59:00Z',
  },
  {
    liquidationNumber: 'LIQ-921560',
    infractionType: 'Défaut de visite technique',
    amount: 75000,
    infractionDate: '2026-06-25T10:05:00Z',
    dueDate: '2026-07-25T23:59:00Z',
  },
  {
    liquidationNumber: 'LIQ-921561',
    infractionType: 'Usage du téléphone au volant',
    amount: 25000,
    infractionDate: '2026-06-22T17:45:00Z',
    dueDate: '2026-07-22T23:59:00Z',
  },
  {
    liquidationNumber: 'LIQ-921562',
    infractionType: 'Conduite sans permis valide',
    amount: 600000,
    infractionDate: '2026-06-18T07:55:00Z',
    dueDate: '2026-07-18T23:59:00Z',
  },
  {
    liquidationNumber: 'LIQ-921563',
    infractionType: 'Transport irrégulier de personnes',
    amount: 450000,
    infractionDate: '2026-06-15T11:20:00Z',
    dueDate: '2026-07-15T23:59:00Z',
  },
  {
    liquidationNumber: 'LIQ-921564',
    infractionType: 'Excès de vitesse (récidive)',
    amount: 90000,
    infractionDate: '2026-06-12T19:10:00Z',
    dueDate: '2026-07-12T23:59:00Z',
  },
  {
    liquidationNumber: 'LIQ-921565',
    infractionType: 'Stationnement gênant',
    amount: 15000,
    infractionDate: '2026-06-10T08:00:00Z',
    dueDate: '2026-07-10T23:59:00Z',
  },
  {
    liquidationNumber: 'LIQ-921566',
    infractionType: 'Non-port de la ceinture',
    amount: 10000,
    infractionDate: '2026-06-08T13:25:00Z',
    dueDate: '2026-07-08T23:59:00Z',
  },
];
